const parseHtml = (elem) => {
  // elem HTML 结构 <span data-w-e-type="mention" data-w-e-is-void data-w-e-is-inline data-value="张三" data-info="xxx">@张三</span>

  const value = elem.getAttribute('data-value') || '';
  const userId = elem.getAttribute('data-user-id') || '';
  return {
    type: 'mention',
    value,
    userId,
    children: [{ text: '' }] // void node 必须有一个空白 text
  };
};

const parseHtmlConf = {
  selector: 'span[data-w-e-type="mention"]',
  parseElemHtml: parseHtml
};

export default parseHtmlConf;
